export type Maybe<T> = T | null;
export type HTMLString = string;
export type DateString = string;

export type CatalogId = string;
export type Namespace = string;
export type AppName = string;
export type ProductName = string;
export type ProductSlug = string;
export type GameId = string;

// @depreciated - import {Action} from 'redux';
export interface Action<PayloadType> {
    type: string;
    payload?: PayloadType;
}

export interface GraphQlQuery {
    query: string;
    variables: {
        [key: string]: string | number | boolean;
    };
}

export enum AsyncValueState {
    notAsked = 'notAsked',
    fetching = 'fetching',
    success = 'success',
    error = 'error'
}

export interface AsyncValue<T, E> {
    state: AsyncValueState;
    latestValue?: T;
    latestError?: E;
}
